"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
/**
 * Combines two arrays of type T into one array with @max items
 * @param {T[]} arr1
 * @param {T[]} arr2
 * @param {number} max
 * @return {T[]}
 */
function combineArrays(arr1, arr2, max) {
    var end = Math.min(Math.max(max - arr1.length, 0), max);
    return arr1.slice(0, max).concat(arr2.slice(0, end));
}
exports.combineArrays = combineArrays;
/**
 * flattens 2 a dimensional array
 * @param {any[][]} arr
 * @return {any[]}
 */
function flatten(arr) {
    if (!Array.prototype.flat) {
        //IE
        return [].concat.apply([], tslib_1.__spread(arr));
    }
    return arr.flat();
}
exports.flatten = flatten;
//# sourceMappingURL=utils.js.map